import { ICartItem, ICartItemObject, IError, IOffer } from '../models';

export const getCartEntriesSortedByModuleType = (
	cartItems: ICartItem[],
	allOffers: IOffer[],
): [string, ICartItem[]][] => {
	const tollSection = allOffers.find(({ moduleTypeId }) => moduleTypeId === 3);
	const cartItemsByModuleType: ICartItemObject = cartItems
		.sort(
			({ offer: { moduleTypeId: moduleTypeIdA } }, { offer: { moduleTypeId: moduleTypeIdB } }) =>
				moduleTypeIdA - moduleTypeIdB,
		)
		.reduce((acc: ICartItemObject, cartItem: ICartItem) => {
			const {
				offer: { moduleType, moduleTypeId },
			} = cartItem;
			if (moduleTypeId === 4) {
				acc[tollSection?.moduleType || moduleType] = !acc[tollSection?.moduleType || moduleType]
					? [cartItem]
					: [...acc[tollSection?.moduleType || moduleType], cartItem];
			} else {
				acc[moduleType] = !acc[moduleType] ? [cartItem] : [...acc[moduleType], cartItem];
			}
			return acc;
		}, {});

	return Object.entries(cartItemsByModuleType);
};

// TODO: change res to errors to reutilise method easier
export const getErrorTextFromResponse = (errors: IError[], label?: string) => {
	const errorText = errors[0].errorText;
	return errorText.length > 0
		? errors[0].errorText
		: label || 'Leider ist etwas schiefgelaufen. Versuchen Sie es bitte erneut.';
};
